export enum ErrorCodes {
  InsufficientFunds = 133,
  InvalidGeolocation = 630,
  DepositLimitationExceeded = 190
}
